// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"843eb22d","304":"10e97cc1","328":"19588dca","819":"8df90d02","859":"e84212c6","931":"60c89825"}[chunkId] + ".chunk.js";
};